import { kiraB50Thumbnail, LocationIcon } from 'assets/images';
import PropType from 'prop-types';

export const MachineMapPin = ({ machineAlias, machineType, text }) => {
  return (
    <div className="machine-map-pin">
      <div className="machine-map-pin__background" />
      <div className="machine-map-pin__content">
        <img
          className="machine-map-pin__machine-image"
          src={kiraB50Thumbnail}
          alt="Kira B 50"
        />

        <div className="machine-map-pin__machine-info">
          <p
            className="machine-map-pin__machine-name"
            title={`${machineAlias} ${machineType}`}>
            <span className="machine-map-pin__machine-alias">
              {machineAlias}
            </span>
            <span className="machine-map-pin__machine-type">{machineType}</span>
          </p>
          <div className="machine-map-pin__text" title={text}>
            {text}
          </div>
        </div>

        <LocationIcon className="machine-map-pin__pin-image" />
      </div>
    </div>
  );
};

MachineMapPin.defaultProps = {
  text: ''
};

MachineMapPin.propTypes = {
  machineAlias: PropType.string.isRequired,
  machineType: PropType.string.isRequired,
  text: PropType.string
};
